import React from "react";
import { Flex } from "@chakra-ui/react";

export const DeployOnRailwayButton: React.FC<{ templateId: string }> = ({
  templateId,
}) => {
  return (
    <Flex>
      <a
        href={`https://railway.app/template/${templateId}`}
        target="_blank"
        rel="noreferrer"
      >
        <img src="https://railway.app/button.svg" alt="Deploy on Railway" />
      </a>
    </Flex>
  );
};
